import { TApplicationState } from "../rootReducer";

export const inEditAnketaModeSelector = (state: TApplicationState) => {
    return state.adminAnketas.adminEditCommentMode.inEditMode;
}

export const beingEditedAnketaIDSelector = (state: TApplicationState) => {
    return state.adminAnketas.adminEditCommentMode.anketaId;
}